import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'sliders-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <circle
                    class="svgWrapperShape"
                    id="path-1"
                    cx="53"
                    cy="53"
                    r="53"
                />
                <path
                    d="M0.141,4.756 C0.047,7.135 1.935,9.14 4.356,9.231 L4.356,9.231 C6.778,9.323 8.816,7.469 8.91,5.089 L8.91,5.089 C9.003,2.709 7.116,0.705 4.695,0.613 L4.695,0.613 C4.637,0.611 4.58,0.609 4.523,0.609 L4.523,0.609 C2.178,0.61 0.232,2.433 0.141,4.756 L0.141,4.756 Z"
                    id="path-3"
                />
                <path
                    d="M1.15,1.884 C-0.247,3.831 0.225,6.521 2.204,7.895 L2.204,7.895 C4.184,9.267 6.922,8.803 8.32,6.857 L8.32,6.857 C9.717,4.911 9.244,2.221 7.264,0.848 L7.264,0.848 C6.495,0.315 5.613,0.058 4.739,0.058 L4.739,0.058 C3.361,0.058 2.004,0.694 1.15,1.884 L1.15,1.884 Z"
                    id="path-5"
                />
                <path
                    d="M16.364,2.681 C15.303,3.991 13.934,5.68 12.565,7.369 L12.565,7.369 C11.197,9.057 9.828,10.745 8.766,12.056 L8.766,12.056 C8.103,12.876 7.885,13.153 7.536,13.588 L7.536,13.588 L1.462,8.399 L0.049,10.521 L6.99,16.451 L7.877,17.213 L8.602,16.282 C8.674,16.188 9.465,15.193 10.525,13.884 L10.525,13.884 C11.585,12.574 12.954,10.885 14.324,9.197 L14.324,9.197 C15.692,7.508 17.06,5.821 18.122,4.509 L18.122,4.509 C19.183,3.198 19.898,2.327 20.099,2.066 L20.099,2.066 L18.287,0.284 C18.215,0.377 17.424,1.372 16.364,2.681 L16.364,2.681 Z"
                    id="path-7"
                />
                <path
                    d="M16.364,3.125 C15.303,4.436 13.934,6.124 12.565,7.813 L12.565,7.813 C11.197,9.501 9.828,11.188 8.766,12.5 L8.766,12.5 C8.103,13.32 7.885,13.597 7.536,14.032 L7.536,14.032 L1.462,8.843 L0.049,10.966 L6.99,16.895 L7.877,17.656 L8.602,16.725 C8.674,16.632 9.465,15.637 10.525,14.329 L10.525,14.329 C11.585,13.017 12.954,11.329 14.324,9.641 L14.324,9.641 C15.692,7.952 17.06,6.265 18.122,4.953 L18.122,4.953 C19.183,3.642 19.898,2.771 20.099,2.51 L20.099,2.51 L18.287,0.728 C18.215,0.821 17.424,1.816 16.364,3.125 L16.364,3.125 Z"
                    id="path-9"
                />
            </defs>
            <g
                id="Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="B-Person-page--more-people-added-"
                    transform="translate(-362.000000, -1615.000000)"
                >
                    <g
                        id="Group-2"
                        transform="translate(365.000000, 1618.000000)"
                    >
                        <g id="Screen-Shot-2019-01-14-at-5.33.33-PM">
                            <mask id="mask-2" fill="white">
                                <use xlink:href="#path-1" />
                            </mask>
                            <use
                                id="Mask"
                                stroke="#0092C8"
                                stroke-width="4.4"
                                fill="#F3FBFE"
                                fill-rule="nonzero"
                                xlink:href="#path-1"
                            />
                        </g>
                        <g
                            id="Group-23"
                            transform="translate(16.000000, 27.000000)"
                        >
                            <polyline
                                id="Fill-1"
                                fill="#3D1C70"
                                points="25.0002 9 25.0002 13 69.0002 13 69.0002 9"
                            />
                            <polygon
                                id="Fill-2"
                                fill="#3D1C70"
                                points="25 13 69 13 69 9 25 9"
                            />
                            <polygon
                                id="Fill-3"
                                fill="#3D1C70"
                                points="25 13 69 13 69 9 25 9"
                            />
                            <polygon
                                id="Fill-4"
                                fill="#3D1C70"
                                points="25 38 69 38 69 34 25 34"
                            />
                            <polygon
                                id="Fill-5"
                                fill="#3D1C70"
                                points="25 38 69 38 69 34 25 34"
                            />
                            <polygon
                                id="Fill-6"
                                fill="#3D1C70"
                                points="25 38 69 38 69 34 25 34"
                            />
                            <g
                                id="Group-9"
                                transform="translate(55.000000, 30.000000)"
                            >
                                <mask id="mask-4" fill="white">
                                    <use xlink:href="#path-3" />
                                </mask>
                                <g id="Clip-8" />
                                <polygon
                                    id="Fill-7"
                                    fill="#FFFFFF"
                                    mask="url(#mask-4)"
                                    points="-4.862 14.234 13.913 14.234 13.913 -4.391 -4.862 -4.391"
                                />
                            </g>
                            <path
                                d="M55.1413,34.7559 C55.2343,32.3759 57.2733,30.5219 59.6953,30.6129 C62.1163,30.7049 64.0033,32.7089 63.9103,35.0889 C63.8163,37.4689 61.7773,39.3229 59.3563,39.2319 C56.9343,39.1389 55.0473,37.1349 55.1413,34.7559 Z"
                                id="Stroke-10"
                                stroke="#2E1F44"
                                stroke-width="1.024"
                            />
                            <g
                                id="Group-14"
                                transform="translate(42.000000, 6.000000)"
                            >
                                <mask id="mask-6" fill="white">
                                    <use xlink:href="#path-5" />
                                </mask>
                                <g id="Clip-13" />
                                <polygon
                                    id="Fill-12"
                                    fill="#FFFFFF"
                                    mask="url(#mask-6)"
                                    points="-4.653 13.684 14.123 13.684 14.123 -4.941 -4.653 -4.941"
                                />
                            </g>
                            <path
                                d="M43.1496,7.8843 C44.5466,5.9383 47.2846,5.4743 49.2646,6.8473 C51.2446,8.2203 51.7166,10.9103 50.3196,12.8573 C48.9226,14.8033 46.1846,15.2673 44.2046,13.8943 C42.2256,12.5213 41.7526,9.8303 43.1496,7.8843 Z"
                                id="Stroke-15"
                                stroke="#2E1F44"
                                stroke-width="1.024"
                            />
                            <g id="Group-19">
                                <mask id="mask-8" fill="white">
                                    <use xlink:href="#path-7" />
                                </mask>
                                <g id="Clip-18" />
                                <polygon
                                    id="Fill-17"
                                    fill="#422B63"
                                    mask="url(#mask-8)"
                                    points="-4.951 22.212 25.098 22.212 25.098 -4.717 -4.951 -4.717"
                                />
                            </g>
                            <g
                                id="Group-22"
                                transform="translate(0.000000, 24.000000)"
                            >
                                <mask id="mask-10" fill="white">
                                    <use xlink:href="#path-9" />
                                </mask>
                                <g id="Clip-21" />
                                <polygon
                                    id="Fill-20"
                                    fill="#422B63"
                                    mask="url(#mask-10)"
                                    points="-4.951 22.656 25.098 22.656 25.098 -4.273 -4.951 -4.273"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class SlidersIconComponent {
    @Input()
    iconSize: IconSize;
}
